import React, { useState } from 'react';
import PropTypes from "prop-types";
import AvailabilityButton from "../../Buttons/AvailabilityButton";
import { isSameDay } from "date-fns";
import { dateFromState } from "../../../Helpers/DateTimeHelper";

const AVAILABILITY_BUTTONS = 7;

const SingleAvailabilitySlotSelector = (props) => {

    const [availabilitiesExpanded, setAvailabilitiesExpanded] = useState(false);

    let availabilitiesRendered = 0;

    /**
     * Should a particular slot be displayed?
     * Note that there is an almost equivalent function in AmenityConsecutiveAvailability
     * @param slot
     * @returns {boolean}
     */
    const shouldShowSlot = (slot) => {
        if (availabilitiesRendered > AVAILABILITY_BUTTONS && !availabilitiesExpanded) {
            return false;
        }

        if (isSameDay(dateFromState(slot.start), dateFromState(props.bookingDate))) {
            availabilitiesRendered++;
            return true;
        }

        return false;
    }

    if (props.timeslotsRemaining !== null && props.timeslotsRemaining < 1) {
        return null;
    }

    return (<div className="availability-container">
        <div className="button-group margin-bottom-0">
            { props.availableIntervals.map((slot, index) => {
                if (shouldShowSlot(slot)) {
                    return (
                        <AvailabilityButton
                            key={index}
                            availability={slot}
                            date={props.bookingDate}
                            onClick={props.onClick}
                        />
                    )
                }
            })}

            { (!availabilitiesExpanded && props.availableIntervals.length > AVAILABILITY_BUTTONS) && (
                <button
                    type="button"
                    className="button availability-button secondary round"
                    onClick={(e) => setAvailabilitiesExpanded(true)}
                >
                    More
                </button>
            )}

            { (availabilitiesExpanded) && (
                <button
                    type="button"
                    className="button availability-button secondary round"
                    onClick={(e) => setAvailabilitiesExpanded(false)}
                >
                    Less
                </button>
            )}
        </div>
    </div>);
}

SingleAvailabilitySlotSelector.propTypes = {
    availability: PropTypes.array,
    bookingDate: PropTypes.any,
    onClick: PropTypes.func,
}

SingleAvailabilitySlotSelector.defaultProps = {
    
}

export default SingleAvailabilitySlotSelector;
